var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"patent-center"},[_c('PatientLeft'),_vm._v(" "),_c('article',{staticClass:"patient-chart"},[(_vm.patientComponent === 'pd')?_c('PDChart'):(_vm.patientComponent === 'range')?_c('RangeChart'):(_vm.patientComponent === 'focus')?_c('FocusChart'):(_vm.patientComponent === 'training')?_c('TrainingChart'):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-251ecc3f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/PatientCenter.vue
// module id = 250
// module chunks = 0